<template>
    <PromptEntityIndicator :detected-entities="recognizedPromptEntities" />
</template>

<script setup lang="ts">
    import {toRef} from 'vue';
    import PromptEntityIndicator from './PromptEntityIndicator.vue';
    import {usePromptEntities} from '../../composables/usePromptEntities';

    const props = defineProps<{
        prompt: string;
    }>();

    const {recognizedPromptEntities} = usePromptEntities(toRef(() => props.prompt));
</script>
